import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const RegistrarRankingsPage = lazy(() => import('./RegistrarRankingsPage'));

const path = 'reports/ranking';
const RegistrarRankingsRoute: FuseRouteItemType = {
	path: path,
	element: <RegistrarRankingsPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Registrar Rankings',
					helpName: 'Ranking',
					showTitle: false,
					showCrumbs: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default RegistrarRankingsRoute;
